<template>
  <div class="chat__contact flex items-center px-2 pt-4 pb-2" :class="{activeChat:isThreadActive}" @click="handleActiveThread(thread.group_id)">
    <div class="contact__avatar mr-1">
         <!-- <vs-avatar class="border-2 border-solid border-white" src="https://scoolio-files.s3.ap-south-1.amazonaws.com/20201027120008350001/Default/7eWD1zcDwXfAbGLL.png" size="40px" /> -->
      <div style="display: flex; justify-content: center; align-items: center; width: 40px; height: 40px; background: rgba(var(--vs-primary), 0.12); border-radius: 50%; margin-right: 5px;">
        <span style="color: rgba(var(--vs-primary), 1);" class="material-icons-outlined">groups</span>
      </div>
    </div>
    <div class="contact__container flex items-center justify-between overflow-hidden" style="width:100%;">
      <div class="contact__info flex flex-col truncate w-4/6">
          <h5 style="font-size: 14px;" class="font-semibold">{{ thread.group_name }}</h5>
          <div v-if=" thread.last_message_details && thread.last_message_details.message_time !== '' && Number(thread.last_message_details.is_attachment) === 1">
            <span v-if="thread.last_message_details && thread.last_message_details.message_time !== ''" class="truncate">
              {{ thread.last_message_details.message.split('/').pop() }}
            </span>
          </div>
          <div v-else>
            <span v-if="thread.last_message_details && thread.last_message_details.message_time !== ''" class="truncate">{{ thread.last_message_details.message }}</span>
          </div>
          
      </div>
    </div>
    <div class="chat__contact__meta flex self-end justify-end flex-col items-end w-2/6">
      <!-- <p class="whitespace-no-wrap" style="text-align:right;font-size:11px;">{{ thread.last_message_details.message_time | moment("dddd, MMMM Do") }}</p> -->

      <p v-if="thread.last_message_details && thread.last_message_details.message_time !== ''" class="whitespace-no-wrap" style="text-align:right;font-size:11px;">{{ thread.last_message_details.message_time | moment("from") }}  </p>
      <!-- <vs-chip class="number" color="primary">{{ unseenMsg }}</vs-chip> -->   
    </div>
    <div v-if="Number(thread.created_by) === this.currentUserId && thread.created_by_type === 'User' ">
      <p class="groupDelete" @click.stop="openDeleteGroupConfirm(thread.group_id)">x</p>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { fetchChatHistory, deleteGroup } from '@/api/message'
import {messageMixin} from './mixin/messageMixin'
import {EventBus} from './mixin/EventBus'

export default {
  data () {
    return {
      lastMessageDate:'',
      currentUserId: 0
    }
  },
  props: {
    thread: {
      type:Object,
      required: true
    },
    fetchChat:{}
  },
  mixins: [messageMixin],
  computed: {
    ...mapGetters(['ChatRelatedTo', 'GroupActiveThread', 'tabActive']),
    isThreadActive () {
      
      if (this.GroupActiveThread === this.thread.group_id) {
        return true
      }
    }
  },
  mounted () {
    let group_id = ''
    this.currentUserId = Number(JSON.parse(localStorage.userInfo).id)
    group_id = this.GroupActiveThread
    if (group_id && this.fetchChat) {
      this.handleActiveThread(group_id)
    }
  },
  methods: {
    ...mapActions(['SET_GROUP_ACTIVE_THREAD']),
    async handleActiveThread (group_id) {
      // 
      this.SET_GROUP_ACTIVE_THREAD(group_id)
      try {
        // 
        const payload = {
          another_user_id : null,
          from_user_type : 'User',
          group_id,
          last_id : null,
          is_client_message_type: this.ChatRelatedTo,
          customer_id:localStorage.getItem('customer_id')
        }
        const { data } = await fetchChatHistory(payload)
        // 
        EventBus.$emit('singleChatClicked', data.data)
      } catch (e) {
        
      }
      
    },
    openDeleteGroupConfirm (group_id) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure about deleting this group ?',
        accept:this.acceptDeleteGroupAlert,
        acceptText:'Yes',
        cancelText:'No',
        parameters:[group_id]
      })
    },
    acceptDeleteGroupAlert (group_id) {
      this.$vs.notify({
        color:'success',
        title:'Success',
        text:'Group Deleted'
      })
      this.deleteGroup(group_id[0])
    },
    async deleteGroup (group_id) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const data = await deleteGroup(customer_id, group_id)
        EventBus.$emit('groupDeleted')
        
      } catch (e) {
        
      }
    }
  }
}
</script>
<style scoped>
.activeChat {
  background-color: rgba(var(--vs-primary), 0.6);
}

.groupDelete{
    margin-right: 10px;
    padding: 2px 9px;
    box-shadow: 0px 0px 5px #ac9e9e3b;
    border-radius: 4px;
    color: black;
    transition: all 0.2s;
}

.groupDelete:hover {
    background: rgba(var(--vs-primary), 1);
    color: white;
}
</style>

